const parseQueryParams = (query) => {
  const queryParams = {};
  if (query) {
    const queryArray = query.split('?');
    if (queryArray && queryArray[1]) {
      const qa1 = queryArray[1].split('&');
      if (qa1 && qa1[0]) {
        for (let i = 0; i < qa1.length; i++) {
          const [key, val] = qa1[i].split('=');
          queryParams[key] = val;
        }
      }
    }
  }
  return queryParams;
};

export {parseQueryParams};


// WEBPACK FOOTER //
// ./src/app/utils/url.js